import { Tabs as BpsTabs, type TabsProps } from './Tabs';
import { Tab, type TabProps } from './Tab';

export type { TabsProps, TabProps };
export { Tab };
export const Tabs = Object.assign(BpsTabs, { Tab });
